"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formatStringFromNumber = formatStringFromNumber;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));
function formatStringFromNumber(number, decimalPointChar, thousandsSeparatorChar) {
  decimalPointChar = decimalPointChar || '.';
  thousandsSeparatorChar = thousandsSeparatorChar || ',';
  if (decimalPointChar === thousandsSeparatorChar) {
    throw new Error('The decimal point and thousands separator characters must be different.');
  }
  if (number === undefined) {
    return '';
  }
  const numberString = number.toString();
  const [wholeNumber, decimals] = numberString.split('.');

  // format whole number part
  const wholeNumberParts = [];
  let remainingWholeNumber = wholeNumber;
  while (remainingWholeNumber.length) {
    const slice = (0, _slice.default)(remainingWholeNumber).call(remainingWholeNumber, -3);
    wholeNumberParts.unshift(slice);
    remainingWholeNumber = (0, _slice.default)(remainingWholeNumber).call(remainingWholeNumber, 0, -slice.length);
  }
  const formattedWholeNumberPart = wholeNumberParts.join(thousandsSeparatorChar);

  // format decimal part
  const formattedDecimalPart = decimals ? `${decimalPointChar}${decimals}` : '';
  return `${formattedWholeNumberPart}${formattedDecimalPart}`;
}